import { FC } from 'react';
import { RECORDS_TABLE_NAME } from '@/entities/conversations';
import { DialogListDataGrid, useDialogListState } from '@/pages/dialogs';
import { PageContainer } from '@/shared/ui';
import { useRecordsPicking } from '../model/useRecordsPicking';
import { RecordsUploadBlock } from './RecordsUploadBlock';

/**
 * Раздел «Загрузка записей»: блок загрузки над списком диалогов. Список — тот же, что в разделе
 * диалогов, со своим видом и без поиска по содержимому, пресетов и массовых действий. Отметки строк
 * ведёт страница: по ним блок загрузки проставляет значения набора отмеченным записям.
 */
export const RecordsPage: FC = () => {
  const { pickedIds, rowSelectionOverride, clearPicked } = useRecordsPicking();
  const { gridProps, list } = useDialogListState({
    sectionKey: RECORDS_TABLE_NAME,
    rowSelectionOverride,
    hasMassActions: false,
    hasContentSearch: false,
  });

  return (
    <PageContainer isFullHeight limitedWidth={false} className="flex flex-col gap-4">
      <RecordsUploadBlock pickedIds={pickedIds} onApplied={clearPicked} onRecordsChanged={list.reload} />
      {/* Растущий блок загрузки не ужимает список ниже этой высоты — дальше прокручивается страница */}
      <div className="min-h-64 grow basis-0">
        <DialogListDataGrid {...gridProps} isRowSelectionActive />
      </div>
    </PageContainer>
  );
};
